var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vks-s2g-drawer research-data-table-wrapper" },
    [
      _vm.loading
        ? _c("div", { staticClass: "vks-ui-status" }, [
            _vm._v(" Loading SNP-to-gene links… "),
          ])
        : _vm.error
        ? _c(
            "div",
            {
              staticClass: "vks-ui-error vks-ui-error--boxed",
              attrs: { role: "alert" },
            },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm._e(),
      _c(
        "section",
        { staticClass: "vks-drawer-section vks-drawer-section--controls" },
        [
          _c("div", { staticClass: "vks-ui-btn-row" }, [
            _c(
              "button",
              {
                staticClass: "vks-ui-btn vks-ui-btn--primary",
                attrs: {
                  type: "button",
                  disabled: !_vm.canLoad || _vm.loading,
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("load")
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.hasTrackData
                        ? "Reload SNP to gene data"
                        : "Load SNP to gene data"
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "vks-ui-btn vks-ui-btn--secondary",
                attrs: {
                  type: "button",
                  disabled: !_vm.hasTrackData || _vm.loading,
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("clear")
                  },
                },
              },
              [_vm._v(" Clear ")]
            ),
          ]),
          _vm.hasTrackData && _vm.geneOptions.length
            ? [
                _c("section", { staticClass: "vks-ui-section" }, [
                  _c("p", { staticClass: "vks-ui-section-title" }, [
                    _vm._v("Genes"),
                  ]),
                  _c("label", { staticClass: "vks-s2g-gene-select-all" }, [
                    _c("input", {
                      attrs: {
                        type: "checkbox",
                        "aria-label": "Select all genes",
                      },
                      domProps: {
                        checked: _vm.allGenesSelected,
                        indeterminate:
                          _vm.someGenesSelected && !_vm.allGenesSelected,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.onSelectAllGenes($event)
                        },
                      },
                    }),
                    _c("span", [_vm._v("Select all")]),
                  ]),
                  _c(
                    "ul",
                    {
                      staticClass: "vks-ui-filter-list",
                      attrs: { role: "group", "aria-label": "Genes" },
                    },
                    _vm._l(_vm.geneOptions, function (gene) {
                      return _c(
                        "li",
                        { key: gene, staticClass: "vks-ui-filter-item" },
                        [
                          _c("label", [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: { checked: _vm.isGeneSelected(gene) },
                              on: {
                                change: function ($event) {
                                  return _vm.onToggleGene(gene, $event)
                                },
                              },
                            }),
                            _c("span", [_vm._v(_vm._s(gene))]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "section",
        { staticClass: "vks-drawer-section vks-drawer-section--table" },
        [
          _c("VariantSifterV2gTable", {
            attrs: {
              rows: _vm.tableRows,
              utils: _vm.utils,
              columns: _vm.s2gTableColumns,
              "show-promoter": false,
              "show-tissue-biosample": false,
              "empty-message": "",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }